import { ChannelsNames } from 'modules/application/detail/channels/Channels';
import '!ng-cache-loader!./ExclusiveComponentsModalSubmoduleView.html';
export class ExclusiveComponentsModalController {
    static $inject = ['close', 'addBlipChatCopyAndPasteState'];
    constructor(close, addBlipChatCopyAndPasteState) {
        this.close = close;
        this.addBlipChatCopyAndPasteState = addBlipChatCopyAndPasteState;
        this.open = true;
        this.channelsNamesEnum = ChannelsNames;
        this.selectedChannel = undefined;
        this.$onInit = () => {
            this.addEventListenerOnInit();
        };
        this.addEventListenerOnInit = () => {
            const blipChatCardElement = document.getElementById('blipchat-card');
            blipChatCardElement.addEventListener('click', () => this.setSelectedChannel(ChannelsNames.Blipchat));
            const closeButtonElement = document.getElementById('exclusive-content-close-button');
            closeButtonElement.addEventListener('click', () => this.closeModal());
        };
        this.setSelectedChannel = (channel) => {
            this.selectedChannel = channel;
        };
        this.closeModal = () => {
            this.close();
        };
        this.onAddBlipChatCopyAndPasteState = () => {
            this.addBlipChatCopyAndPasteState();
            this.closeModal();
        };
    }
}
ExclusiveComponentsModalController.$inject = ['close', 'addBlipChatCopyAndPasteState'];
